import DashboardUIProvider from "@contexts/dashboardUI"
import ProjectProvider from "@contexts/projects"
import Dashboard from "./Dashboard"
import CostsProvider from "@contexts/costs"
import BimProvider from "@contexts/bim"
import DirectorProvider from "@contexts/director"


const DashboardContainer = () => (
  <DashboardUIProvider>
    <BimProvider>
      <CostsProvider>
        <ProjectProvider>
          <DirectorProvider>
            <Dashboard />
          </DirectorProvider>
        </ProjectProvider>
      </CostsProvider>
    </BimProvider>
  </DashboardUIProvider>
)
export default DashboardContainer
